var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99976 6.66162C5.87926 6.66162 5.76709 6.64237 5.66326 6.60388C5.55942 6.56554 5.46067 6.49954 5.36701 6.40588L0.872758 1.91163C0.734425 1.77313 0.663591 1.59913 0.660258 1.38963C0.657091 1.17996 0.727925 1.00271 0.872758 0.857875C1.01776 0.713042 1.19342 0.640625 1.39976 0.640625C1.60609 0.640625 1.78176 0.713042 1.92676 0.857875L5.99976 4.93088L10.0728 0.857875C10.2113 0.719375 10.3853 0.648542 10.595 0.645375C10.8045 0.642208 10.9818 0.713042 11.1268 0.857875C11.2716 1.00271 11.344 1.17829 11.344 1.38463C11.344 1.59113 11.2716 1.76679 11.1268 1.91163L6.63251 6.40588C6.53884 6.49954 6.44009 6.56554 6.33626 6.60388C6.23242 6.64237 6.12026 6.66162 5.99976 6.66162Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/down-arrow-icon.b75e3d45e9f37644001f154c70d75d26.svg";
export { ForwardRef as ReactComponent };